import React from "react";
import { 
    Level, LevelItem, Grid, GridItem, List, ListItem, Progress, ProgressSize, Tooltip, Icon
} from '@patternfly/react-core';
import CheckCircleIcon from '@patternfly/react-icons/dist/esm/icons/check-circle-icon';
import ExclamationCircleIcon from '@patternfly/react-icons/dist/esm/icons/exclamation-circle-icon';
import ArrowRightIcon from '@patternfly/react-icons/dist/esm/icons/arrow-right-icon';
import StorageDomainIcon from '@patternfly/react-icons/dist/esm/icons/storage-domain-icon';
import { formatBytes } from 'shared/utils/formatBytes'

const DiskInfo = ({
  vm
}) => {
  const diskUtilization = (provisioned_size, actual_size) => {
    if (!provisioned_size || provisioned_size === 0) return null; // unikamy dzielenia przez zero
    const percent = Math.round((actual_size / provisioned_size) * 100);
    return (
      <Progress
        // title={`${formatBytes(actual_size)} of ${formatBytes(provisioned_size)}`}
        value={percent}
        size={ProgressSize.sm}
        aria-label="Wykorzystanie dysku"
      />
    );
  };
  return (
    <>
    <Grid
      hasGutter
      span={12} 
      style={{
          fontSize: "12px",
          lineHeight: "1.6"
      }}
    >
      <>
      <GridItem span={12}>
        <Level>
          <LevelItem><StorageDomainIcon style={{marginRight: '5px'}}/> <b>Dyski:</b></LevelItem>
          <LevelItem>
          </LevelItem>
        </Level>
        {vm?.disks.map((disk) => (
          <React.Fragment key={disk.id || disk.name}>
          <List style={{listStyleType: 'none'}}>
            <ListItem style={{listStyleType: 'none', margin: "0px"}}>
              {/* {disk?.logical_name === null ?  `[ ${disk?.interface} ]` : `${disk?.logical_name} [ ${disk?.interface} ]`} */}
              <>
              <Level>
              <LevelItem>
                {disk?.logical_name === null
                  ? `[ ${disk?.interface} ]`
                  : `${disk?.logical_name} [ ${disk?.interface} ]`}
              </LevelItem>

              {/* Prawe miejsce - status i bootable */}
              <LevelItem>
                {disk.status === "ok" ? (
                  <>
                  <Tooltip content={<div>Link status: {disk.status}</div>}>
                    <Icon status="success">
                      <CheckCircleIcon />
                    </Icon>
                  </Tooltip>
                  </>
                ) : (
                  <>
                  <Tooltip content={<div>Link status: {disk.status}</div>}>
                    <Icon status="danger">
                      <ExclamationCircleIcon />
                    </Icon>
                  </Tooltip>
                  </>
                )}
                {disk.bootable === "true" && (
                  <>
                  {' '} <Tooltip content={<div>Bootable: {disk.bootable}</div>}><ArrowRightIcon /></Tooltip>
                  </>
                )}
              </LevelItem>
              </Level>
              </>
              <List style={{listStyleType: 'none', paddingTop: "0px"}}>
                <ListItem>
                  <Level>
                    <LevelItem>Dostęne:</LevelItem>
                    <LevelItem>
                        {formatBytes(disk.provisioned_size - disk.actual_size)} z {formatBytes(disk.provisioned_size)}
                    </LevelItem>
                  </Level>
                  {diskUtilization(disk.provisioned_size, disk.actual_size)}
                </ListItem>
              </List>
            </ListItem>
          </List>
          </React.Fragment>
        ))}
      </GridItem>
      </>
    </Grid>
      {/* <GridItem span={12}>
        {vm?.nics.map((nic) => (
          <React.Fragment key={nic.id || nic.name}>
          <Level>
            <LevelItem><StorageDomainIcon style={{marginRight: '5px'}}/> <b>Dyski:</b></LevelItem>
            <LevelItem>
            </LevelItem>
          </Level>
          <List style={{listStyleType: 'none'}}>
            <ListItem style={{listStyleType: 'none', margin: "0px"}}>
              <b>{nic.name}</b> {nic?.reporteddevices_data?.reported_device?.length > 0 && (
                nic.reporteddevices_data.reported_device.map((device) => (
                    vm.status === "up" && ` (${device.name})`
                ))
              )}
              <List style={{listStyleType: 'none', paddingTop: "0px"}}>
                <ListItem>
                  <Level>
                    <LevelItem>IP Address:</LevelItem>
                    <LevelItem>
                      {nic?.reporteddevices_data?.reported_device?.length > 0 && vm.status === "up" ? (
                        nic.reporteddevices_data.reported_device.map((device) => (
                          <span key={device.id}>
                            <ClipboardCopy 
                              copyAriaLabel="Copy inline compact example"
                              hoverTip="Kopiuj"
                              clickTip="Skopiowano"
                              variant="inline-compact"
                              style={{marginRight: "0px", paddingRight: "0px"}}
                            >
                          {device.ips?.ip
                            ?.filter((ip) => ip.version === "v4")
                            .map((ip) => ip.address)
                            .join(", ")}
                            </ClipboardCopy>
                        </span>
                      ))
                      ) : (
                        "N/A"
                      )}
                    </LevelItem>
                  </Level>
                  <Level>
                    <LevelItem>MAC:</LevelItem>
                    <LevelItem>
                      <ClipboardCopy 
                        copyAriaLabel="Copy inline compact example"
                        hoverTip="Kopiuj"
                        clickTip="Skopiowano"
                        variant="inline-compact"
                        style={{marginRight: "0px", paddingRight: "0px"}}
                      >
                        {nic.mac.address}
                      </ClipboardCopy>
                    </LevelItem>
                  </Level>
                </ListItem>
              </List>
            </ListItem>
          </List>
          </React.Fragment>
        ))}
      </GridItem>
      </>
    </Grid> */}
    </>
  );
};

export default DiskInfo;